import 'summernote/dist/summernote-lite.min';

export default {
    init() {
      
    },

    priceTypeScripts(){
        if($('#price_type_useFormula').is(":checked")){
                toggleFormula(true);
        }
        else{
            toggleFormula(false);
        }

        $(document).on('change', '#price_type_useFormula', function (e) {
            if($(this).is(":checked")){
                toggleFormula(true);
            }
            else{
                toggleFormula(false);
            }
        });


        function toggleFormula(show){
            if(show){
                $('#formula-settings').show();
            }
            else{
                $('#formula-settings').hide();
            }
        }
    },

    stockScripts(){
        $('#submit-btn').on('click', function(e){
            if($('form')[0].checkValidity()){
                e.preventDefault();
                var el = $('#storage_title');
                $.ajax({
                    type: "POST",
                    url: "/manage/storage/info/check-uniq",
                    data: {
                        value: el.val(),
                        storage_id: $('#storageid').html(),
                    },
                    dataType: "json",
                    success: function(response) {
                        if(response){
                            $('form').submit();
                        }
                        else{
                            el[0].setCustomValidity("Please enter a unique value");
                            el[0].reportValidity();
                            el[0].addEventListener('input', function(){
                                el[0].setCustomValidity("");
                            });
                        }
                    }
                });
            }
        });
    },

    serviceScripts(){

        var targets = $('.condition-field-type');

        targets.each(function( index ) {
            var options = $(this).parent().parent().parent().parent().find('.condition-fields option');
            var type= $(this).val();
            options.each(function( index ) {
                if($(this).attr('related') == type){
                    $(this).removeAttr('disabled');
                }
                else{
                    $(this).attr('disabled','disabled');
                }
            });
        });

       

        $(document).on('change', '.condition-field-type', function (e) {
            var relatedField = $(this).parent().parent().parent().parent().find('.condition-fields');
            relatedField.select2('val', '');
            relatedField.parent().parent().find('.multi-select-list').html('');
            
            $(this).parent().parent().parent().parent().find('.condition-fields').val([]).trigger("change");
  
            var options = $(this).parent().parent().parent().parent().find('.condition-fields option');
            var type= $(this).val();
            options.each(function( index ) {
                if($(this).attr('related') == type){
                    $(this).removeAttr('disabled');
                }
                else{
                    $(this).attr('disabled','disabled');
                }
            });
        });
    },
    tableScrips(){
        $('#quick-filters button:first-child').addClass( "active" );

        //on next click
        $(document).on('click', '.next', function (e) {
            e.preventDefault();
            var currentPage = $('#current-page').val();
  

            // console.log(parseInt($('#total-pages-count').html()) > parseInt((currentPage+1)));
            if(parseInt($('#total-pages-count').html()) >= parseInt(currentPage)+1){
                $('#current-page').val(parseInt(currentPage)+1);
                updateTable(false);

            }
        });

        //on prev click
        $(document).on('click', '.prev', function (e) {
            e.preventDefault();
            var currentPage = $('#current-page').val();
            // console.log(currentPage);
            if(currentPage > 1){
                $('#current-page').val(parseInt(currentPage)-1);
                updateTable(false);
               
            }
        });

        //on current-page field ENTER press
        $(document).on('keypress', '#current-page', function (e) {
            if(e.key == 'Enter') {
                updateTable(false);
            }
        });
        
        //on per page change
        $(document).on('change', '#per-page-selector', function () {
            updateTable(true);
        });

        //on search field ENTER press
        $(document).on('keypress', '#table-search', function (e) {
            if(e.key == 'Enter') {
                var searchedText = this.value;
                updateTable(true);
            }
        });

        //on search field icon click
        $(document).on('click', '#table-search-submit', function (e) {
            updateTable(true);
        });

        //on quick filter click
        $(document).on('click', '.quick-filter-button', function() {
            $('.quick-filter-button').each(function(i, obj) {
                if($(this).hasClass('active')){
                    $(this).removeClass('active')
                }
            });
            $(this).addClass( "active" );
            updateTable(true);
        });

        //on inner filter change
        $(document).on('change', '.inner-filter', function() {
            updateTable(true);
        });

        $(document).on('click', '.download-btn.export', function (e) {
            exportTable(false);
        });

        $(document).on('click', '.download-btn.vumo', function (e) {
            let url = '/manage/products/tomasiVumo';
            window.location.href = url;
        });

        function exportTable(reset = false){
            var searchedText = $('#table-search').val();
            function encodeMultidimensionalParam(prefix, array) {
                let encoded = [];
                for (let i in array) {
                    if (typeof array[i] === "object") {
                        encoded.push(encodeMultidimensionalParam(prefix + '[' + i + ']', array[i]));
                    } else {
                        encoded.push(encodeURIComponent(prefix + '[' + i + ']') + '=' + encodeURIComponent(array[i]));
                    }
                }
                return encoded.join('&');
            }
            
            let params = {
                "search" : searchedText,
                "filters" : gatherFilters(true),
            };
            
            let ret = [];
            for (let d in params)
                ret.push(encodeMultidimensionalParam(d, params[d]));
            
            let url = '/manage/products/export?' + ret.join('&');
            window.location.href = url;
            // let loader = $('.loader-holder');
            // loader.show();
            // while(window.location.href == url){}
            // loader.hide();
        }

         //on detailed filter select change
         $(document).on('change', '#detailed-filters-box select', function () {
            var changedFieldId = $(this).attr('name');
            var selectedOptionId = $(this).val();
            var relatedFields = $( "select[related_id*='"+changedFieldId+"']" );

            relatedFields.each(function(i, obj) {
                $(this).val(null).trigger("change");
                $(this).find('option').each(function() {
                    if($(this).attr('related_option') !== selectedOptionId){
                        $(this).attr('disabled','disabled');
                    }
                    else{
                        $(this).removeAttr('disabled');
                    }
                });
                $(this).prop("disabled", false);
            });
        });

        $(document).on('click', '#detailed-filter-submit', function() {
            updateTableFilter(true);
        });

        $(document).on('click', '.clear-all-filters', function() {
            updateTable(true);
        });

        $('.calendar-start-input-date, .calendar-end-input-date').on('apply.daterangepicker', function (ev, picker) {
            updateTable(true);
        });

        function gatherFilters($detailed){
            var filtersList = {};
            $('.quick-filter-button').each(function(i, obj) {
                if($(this).hasClass('active')){
                    var type = $(this).attr('type');
                    var value = $(this).attr('value');
                    if(!filtersList[type]){
                        filtersList[type] = [];
                    }
                    filtersList[type].push(value);
              
                }
            });

            $('.inner-filter').each(function(i, obj) {
                var value = $(this).val();
                var type = $(this).attr('type');
                if(!filtersList[type]){
                    filtersList[type] = [];
                }
                filtersList[type].push(value);

                
            });
 
            
            if($detailed){
                var detailedFilters = {}
                $('#detailed-filters-box select').each(function(i, obj) {
                    detailedFilters[$(this).attr('name')] = $(this).val();
                });
                $('#detailed-filters-box input').each(function(i, obj) {
                    detailedFilters[$(this).attr('name')] = $(this).val();
                });
               
                filtersList['detailed_filters_array'] = detailedFilters;
            }
            else{
                filtersList['detailed_filters_array'] = [];
            }

            
            var start_date = $('.calendar-start-input-date');
            var end_date = $('.calendar-end-input-date');
            if(start_date.length > 0){
                filtersList['date_filters_array'] = {};
                filtersList['date_filters_array'][[start_date.attr('field')]] = {};
                filtersList['date_filters_array'][start_date.attr('field')]['start'] = '2000-01-01';
                filtersList['date_filters_array'][start_date.attr('field')]['end'] = '2050-12-30'

                if(start_date.val().length > 0){
                    filtersList['date_filters_array'][start_date.attr('field')]['start'] = start_date.val();
                }
                if(end_date.val().length > 0){
                    filtersList['date_filters_array'][end_date.attr('field')]['end'] = end_date.val();
                }
            }
            // console.log(filtersList);
            return filtersList;
        }

        function highlightSearchedText(text){
            const valThis = text;
            if(valThis.length > 0){
                $('.column-value').each(function () {
                    if($(this).find('.block-search').length < 1){
                        const text  = $(this).html();
                        const textL = text.toLowerCase();
                        const position = textL.indexOf(valThis.toLowerCase());
                        if (position !== -1) {
                            const matches = text.substring(position, (valThis.length + position));
                            const regex = new RegExp(matches, 'ig');
                            const highlighted = text.replace(regex, `<mark style="background-color: rgba(31, 229, 163,0.5)">${matches}</mark>`);

                            $(this).html(highlighted).show();
                        } 
                        else {
                            $(this).html(text);
                        }
                    }
                    
                });
            }
        }

        function reInitSelects(){
            let select = $('select.select2');
            if (select.length > 0) {
                select.select2({
                    minimumResultsForSearch: 5,
                });
            }

            let multipleOptions = {
                placeholder: 'Select',
                closeOnSelect : false,
                allowClear: true,
                minimumResultsForSearch: 5
            };
    
            $('select.settings-multi').select2(multipleOptions);

            let selectAllSelect = $('.select-all');
            selectAllSelect.on('select2:select', function () {
                let thisSelect = $(this);
                if (thisSelect.val().includes('Select all')) {
                    thisSelect.select2('destroy').find('option').prop('selected', 'selected').end().select2(multipleOptions);
                }
            });
    
            selectAllSelect.on('select2:unselect', function (e) {
                if (e.params.data.text === 'Select all') {
                    $(this).val(null).trigger('change');
                }
            });
        }

        function updateTable(reset = false){
            if(reset == true){
                var currentPage = 0;
                $('#current-page').val(1)
            }
            else
                var currentPage = $('#current-page').val()-1;


            var searchedText = $('#table-search').val();
            var perPage = $('#per-page-selector').val();
            $.ajax({
                url: window.location.href,
                data: {
                    "page": currentPage,
                    "per_page": perPage,
                    "search" : searchedText,
                    "filters" : gatherFilters(true),
                },
                success: function(response) {
                  
                    $('#table-body-to-refresh').html(response['rows']);
                    $('#total-pages-count').html(response['pages']);

                    // $('#detailed-filters-box').html(response['detailedFiltersHtml']);

                    reInitSelects();
                    highlightSearchedText(searchedText);
                    $('.lots-bid-log-row .column:not(.actions)').on('click', function() {
                        let row = $(this).closest('tr');
                        let packageLink = row.data("lots-log-id");
                        if (row.hasClass('active')) {
                            row.removeClass('active')
                            $('.lots-bid-log-inner[data-lots-log-id=' + packageLink + ']').addClass('hidden');
                        } else {
                            row.addClass('active')
                            $('.lots-bid-log-inner[data-lots-log-id=' + packageLink + ']').removeClass('hidden');
                        }
                    });
                }
            });
        }

        function updateTableFilter(reset = false){
            if(reset){
                var currentPage = 0;
                $('#current-page').val(1)
            }
            else{
                var currentPage = $('#current-page').val();
                
            }

            var searchedText = $('#table-search').val();
            var perPage = $('#per-page-selector').val();

            $.ajax({
                url: window.location.href,
                data: {
                    "page": currentPage,
                    "per_page": perPage,
                    "search" : searchedText,
                    "filters" : gatherFilters(true),
                },
                success: function(response) {
                  
                    $('#table-body-to-refresh').html(response['rows']);
                    $('#total-pages-count').html(response['pages']);
                    // $('#detailed-filters-box').html(response['detailedFiltersHtml']);
                    // reInitSelects();
                    highlightSearchedText(searchedText);
                    $('.lots-bid-log-row .column:not(.actions)').on('click', function() {
                        let row = $(this).closest('tr');
                        let packageLink = row.data("lots-log-id");
                        if (row.hasClass('active')) {
                            row.removeClass('active')
                            $('.lots-bid-log-inner[data-lots-log-id=' + packageLink + ']').addClass('hidden');
                        } else {
                            row.addClass('active')
                            $('.lots-bid-log-inner[data-lots-log-id=' + packageLink + ']').removeClass('hidden');
                        }
                    });
                }
            });
        }








        let counter = $('.auction-filter--added-count .count');

        $('body').on('click', function (e) {
            if ($(e.target).hasClass('add-lot-action')) {
                e.preventDefault();

                if (!$(e.target).parents().eq(3).hasClass('pack-item')) {
                    counter.html(parseInt(counter.html()) + 1);
                } else {
                    let packItem = $(e.target).parents().eq(3);
                    let packCount = packItem.find('.lots-list--item-row--log-list>.lots-list--item-row').length;
                    counter.html(parseInt(counter.html()) + packCount);
                }

                var product_id = $(e.target).attr('product_id');
                var auction_id =  $('#auctionId').html();
               
              
                $.ajax({
                    url: '/manage/auctions/add-lots-ajax',
                    data: {
                        "productIds": [product_id],
                        "auction": auction_id,
                    },
                    success: function(response) {
                        let alertsDiv = $('.add-lots--alerts');
                        Object.entries(response).forEach(function(alertsObj){
                            if(alertsObj[0] == 'warnings'){
                                Object.entries(alertsObj[1]).forEach(function(alert){
                                    alertsDiv.append('<div class="alert alert-warning alert-dismissible fade show" role="alert"><span class="warning"></span>Warning! '+alert[0]+" "+alert[1]+'<button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button></div>');
                                });
                            } else if(alertsObj[0] == 'errors'){
                                Object.entries(alertsObj[1]).forEach(function(alert){
                                    alertsDiv.append('<div class="alert alert-danger alert-dismissible fade show" role="alert"><span class="error"></span>Error! '+alert[0]+" "+alert[1]+'<button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button></div>');
                                });
                            }
                        });
                        updateTable(false);
                        updateLotSideMenu();
                        updateLotSideMenuCount();
                    }
                });
               
                // $(e.target).parents().eq(3).hide();
            }
            else if ($(e.target).hasClass('add-package-action')) {
                e.preventDefault();
                console.log(counter.html());
                // counter.html( parseInt(counter.html()) + 1 );
                // if (!$(e.target).parents().eq(3).hasClass('pack-item')) {
                //     counter.html(parseInt(counter.html()) + 1);
                // } else {
                //     let packItem = $(e.target).parents().eq(3);
                //     let packCount = packItem.find('.lots-list--item-row--log-list>.lots-list--item-row').length;
                //     counter.html(parseInt(counter.html()) + packCount);
                // }

                var product_id = $(e.target).attr('product_id');
                var auction_id =  $('#auctionId').html();
               
                // console.log('to?')
                $.ajax({
                    url: '/manage/auctions/add-lots-ajax',
                    data: {
                        "packageIds": [product_id],
                        "auction": auction_id,
                    },
                    success: function(response) {
                        // console.log('yey?')
                        updateTable(true);
                        updateLotSideMenu();
                        updateLotSideMenuCount();
                    }
                });

            }
        });

        $('body').on('click', function (e) {
            if ($(e.target).hasClass('remove-from-sidebar') && !$(e.target).hasClass('offer')) {
                e.preventDefault();

                // let sideBarCount = $('.lots-sidebar--heading .added span');
                // $(e.target).parents().eq(3).remove();
                // sideBarCount.html( parseInt(sideBarCount.html()) - 1 );

                var product_id = $(e.target).attr('product_id');
                var auction_id =  $('#auctionId').html();

                $.ajax({
                    url: '/manage/auctions/remove-lots-ajax',
                    data: {
                        "productIds": [product_id],
                        "auction": auction_id,
                    },
                    success: function(response) {
                        updateTable(true);
                        updateLotSideMenu();
                        updateLotSideMenuCount();

                    }
                });
            }
        });

        $('body').on('click', function (e) {
            if ($(e.target).hasClass('remove-package-from-sidebar')) {
                e.preventDefault();

                let sideBarCount = $('.lots-sidebar--heading .added span');
                $(e.target).parents().eq(3).remove();
                sideBarCount.html( parseInt(sideBarCount.html()) - 1 );

                var product_id = $(e.target).attr('package_id');
                var auction_id =  $('#auctionId').html();
                //console.log(product_id);
                $.ajax({
                    url: '/manage/auctions/remove-lots-ajax',
                    data: {
                        "packageIds": [product_id],
                        "auction": auction_id,
                    },
                    success: function(response) {
                        updateTable(true);
                        updateLotSideMenu();
                        updateLotSideMenuCount();

                    }
                });
            }
        });

        
        
        $('body').on('click', function (e) {
            if ($(e.target).hasClass('remove-lot-from-auction')) {
                e.preventDefault();
                
                var product_id = $(e.target).attr('product_id');
                var auction_id =  $('#auctionId').html();

                $.ajax({
                    url: '/manage/auctions/remove-lots-ajax',
                    data: {
                        "productIds": [product_id],
                        "auction": auction_id,
                    },
                    success: function(response) {
                        updateTable(true);
                        updateLotSideMenu();
                        updateLotSideMenuCount();

                    }
                });
            }
        });

        $('body').on('click', function (e) {
            if ($(e.target).hasClass('remove-package-from-auction')) {
                e.preventDefault();
                
                var package_id = $(e.target).attr('package_id');
                var auction_id =  $('#auctionId').html();

                $.ajax({
                    url: '/manage/auctions/remove-lots-ajax',
                    data: {
                        "packageIds": [package_id],
                        "auction": auction_id,
                    },
                    success: function(response) {
                        updateTable(true);
                        updateLotSideMenu();
                        updateLotSideMenuCount();

                    }
                });
            }
        });

        $('.remove-all-cart:not(.offer)').on('click', function (e) {
            e.preventDefault();
            var dynamicItems = $('.lots-sidebar--inner .lots-list--item-row--main a');

            var product_ids = {};
            var package_ids = {};
            dynamicItems.each(function (i, val) {

                var product_id = $(val).attr('product_id');
                if(typeof product_id != 'undefined'){
                    product_ids[product_id] = product_id;
                }
                
                var package_id = $(val).attr('package_id');
                if(typeof package_id != 'undefined'){
                    package_ids[package_id] = package_id;
                }
                
            });

            var auction_id = $('#auctionId').html();

            $.ajax({
                url: '/manage/auctions/remove-lots-ajax',
                data: {
                    "productIds": product_ids,
                    "packageIds": package_ids,
                    "auction": auction_id,
                },
                success: function(response) {
                    updateTable(true);
                    updateLotSideMenu();
                    updateLotSideMenuCount();
                }
            });
            $('.lots-sidebar--inner').empty();
            $('.lots-sidebar--heading .added span').html(0);
        });

        $('#group-checkbox-action').on('click', function (e) {
            e.preventDefault();

            let checkedListItems = $('.lots-item-checkbox:checked');
            let countItems = 0;

            var product_ids = [];
            var auction_id =  $('#auctionId').html();


            if (checkedListItems.length > 0) {
                checkedListItems.each(function (i, val) {
                    var product_id = $(val).parent().parent().parent().find('.add-lot-action').attr('product_id');
                    product_ids.push(product_id);
                });
                $.ajax({
                    url: '/manage/auctions/add-lots-ajax',
                    data: {
                        "productIds": product_ids,
                        "auction": auction_id,
                    },
                    success: function(response) {
                        let alertsDiv = $('.add-lots--alerts');
                        Object.entries(response).forEach(function(alertsObj){
                            if(alertsObj[0] == 'warnings'){
                                Object.entries(alertsObj[1]).forEach(function(alert){
                                    alertsDiv.append('<div class="alert alert-warning alert-dismissible fade show" role="alert"><span class="warning"></span>Warning! '+alert[0]+" "+alert[1]+'<button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button></div>');
                                });
                            } else if(alertsObj[0] == 'errors'){
                                Object.entries(alertsObj[1]).forEach(function(alert){
                                    alertsDiv.append('<div class="alert alert-danger alert-dismissible fade show" role="alert"><span class="error"></span>Error! '+alert[0]+" "+alert[1]+'<button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button></div>');
                                });
                            }
                        });
                        updateTable(false);
                        updateLotSideMenu();
                        updateLotSideMenuCount();
                    }
                });
            }
        });

        function updateLotSideMenu(){
            var auction_id =  $('#auctionId').html();
            var sidebar = $('.lots-sidebar');
       
            if(sidebar.length > 0  && auction_id && auction_id.trim() !== ''){
                $.ajax({
                    url: '/manage/auctions/side-menu-lots-by-auction/'+auction_id,
                    data: {},
                    success: function(response) {
                        
                        $('#lot-sidebar-body').html(response);
                        // updateTable(true);
                    }
                });
            }
        }

        function updateLotSideMenuCount(){
            var auction_id =  $('#auctionId').html();
            var sidebar = $('.lots-sidebar');
            if(sidebar.length > 0  && auction_id && auction_id.trim() !== ''){
                $.ajax({
                    url: '/manage/auctions/side-menu-lots-count/'+auction_id,
                    data: {},
                    success: function(response) {
                        $('.auction-filter--added-count .count').html(response);
                        // updateTable(true);
                    }
                });
            }

        }    

        $('body').on('click', function (e) {
            if ($(e.target).hasClass('add-to-pack-action')) {
                e.preventDefault();

                var product_id = $(e.target).attr('product_id');
                var package_id =  $('#package-id').html();
                if(package_id.length < 1){
                    package_id = null;
                }

                var row = $(e.target).parents().eq(2);
                var cloned_row = row.clone();
                cloned_row.find(".add-to-pack-action").addClass('remove-from-pack-action').removeClass('add-to-pack-action').html('REMOVE');
                cloned_row.appendTo("#package-table-body");
                row.remove();
               

                $.ajax({
                    url: '/manage/package/toggle-product-to-package-ajax',
                    data: {
                        "product": product_id,
                        "package": package_id,
                        "add": true
                    },
                    success: function(response) {
                        $('#package-id').html(response);
                        updateTable(true);
                    }
                });
            }
        });

        /* offer */

        $('body').on('click', function (e) {
            if ($(e.target).hasClass('add-lot-action-offer')) {
                e.preventDefault();

                if (!$(e.target).parents().eq(3).hasClass('pack-item')) {
                    counter.html(parseInt(counter.html()) + 1);
                } else {
                    let packItem = $(e.target).parents().eq(3);
                    let packCount = packItem.find('.lots-list--item-row--log-list>.lots-list--item-row').length;
                    counter.html(parseInt(counter.html()) + packCount);
                }

                var product_id = $(e.target).attr('product_id');
                var offer_id =  $('#offerId').html();


                $.ajax({
                    url: '/manage/offers/add-lots-ajax',
                    data: {
                        "productIds": [product_id],
                        "offer": offer_id,
                    },
                    success: function(response) {
                        let alertsDiv = $('.add-lots--alerts');
                        Object.entries(response).forEach(function(alertsObj){
                            if(alertsObj[0] == 'warnings'){
                                Object.entries(alertsObj[1]).forEach(function(alert){
                                    alertsDiv.append('<div class="alert alert-warning alert-dismissible fade show" role="alert"><span class="warning"></span>Warning! '+alert[0]+" "+alert[1]+'<button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button></div>');
                                });
                            } else if(alertsObj[0] == 'errors'){
                                Object.entries(alertsObj[1]).forEach(function(alert){
                                    alertsDiv.append('<div class="alert alert-danger alert-dismissible fade show" role="alert"><span class="error"></span>Error! '+alert[0]+" "+alert[1]+'<button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button></div>');
                                });
                            }
                        });
                        updateTable(false);
                        updateLotSideMenuOffers();
                        updateLotSideMenuCountOffers();
                    }
                });
            }
        });

        $('body').on('click', function (e) {
            if ($(e.target).hasClass('remove-from-sidebar') && $(e.target).hasClass('offer')) {
                e.preventDefault();

                // let sideBarCount = $('.lots-sidebar--heading .added span');
                // $(e.target).parents().eq(3).remove();
                // sideBarCount.html( parseInt(sideBarCount.html()) - 1 );

                var product_id = $(e.target).attr('product_id');
                var offer_id =  $('#offerId').html();

                $.ajax({
                    url: '/manage/offers/remove-lots-ajax',
                    data: {
                        "productIds": [product_id],
                        "offer": offer_id,
                    },
                    success: function(response) {
                        updateTable(true);
                        updateLotSideMenuOffers();
                        updateLotSideMenuCountOffers();

                    }
                });
            }
        });

        $('.remove-all-cart.offer').on('click', function (e) {
            e.preventDefault();
            var dynamicItems = $('.lots-sidebar--inner .lots-list--item-row--main a');

            var product_ids = {};
            dynamicItems.each(function (i, val) {
                var product_id = $(val).attr('product_id');
                if(typeof product_id != 'undefined'){
                    product_ids[product_id] = product_id;
                }
            });

            var offer_id = $('#offerId').html();

            $.ajax({
                url: '/manage/offers/remove-lots-ajax',
                data: {
                    "productIds": product_ids,
                    "offer": offer_id,
                },
                success: function(response) {
                    updateTable(true);
                    updateLotSideMenuOffers();
                    updateLotSideMenuCountOffers();
                }
            });
            $('.lots-sidebar--inner').empty();
            $('.lots-sidebar--heading .added span').html(0);
        });

        $('#group-checkbox-action-offer').on('click', function (e) {
            e.preventDefault();

            let checkedListItems = $('.lots-item-checkbox:checked');
            let countItems = 0;

            var product_ids = [];
            var offer_id =  $('#offerId').html();


            if (checkedListItems.length > 0) {
                checkedListItems.each(function (i, val) {
                    var product_id = $(val).parent().parent().parent().find('.add-lot-action-offer').attr('product_id');
                    product_ids.push(product_id);
                });
                $.ajax({
                    url: '/manage/offers/add-lots-ajax',
                    data: {
                        "productIds": product_ids,
                        "offer": offer_id,
                    },
                    success: function(response) {
                        let alertsDiv = $('.add-lots--alerts');
                        Object.entries(response).forEach(function(alertsObj){
                            if(alertsObj[0] == 'warnings'){
                                Object.entries(alertsObj[1]).forEach(function(alert){
                                    alertsDiv.append('<div class="alert alert-warning alert-dismissible fade show" role="alert"><span class="warning"></span>Warning! '+alert[0]+" "+alert[1]+'<button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button></div>');
                                });
                            } else if(alertsObj[0] == 'errors'){
                                Object.entries(alertsObj[1]).forEach(function(alert){
                                    alertsDiv.append('<div class="alert alert-danger alert-dismissible fade show" role="alert"><span class="error"></span>Error! '+alert[0]+" "+alert[1]+'<button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button></div>');
                                });
                            }
                        });
                        updateTable(false);
                        updateLotSideMenuOffers();
                        updateLotSideMenuCountOffers();
                    }
                });
            }
        });

        function updateLotSideMenuOffers(){
            var offer_id =  $('#offerId').html();
            var sidebar = $('.lots-sidebar');

            if(sidebar.length > 0 && offer_id && offer_id.trim() !== ''){
                $.ajax({
                    url: '/manage/offers/side-menu-lots-by-offer/'+offer_id,
                    data: {},
                    success: function(response) {

                        $('#lot-sidebar-body').html(response);
                        // updateTable(true);
                    }
                });
            }
        }

        function updateLotSideMenuCountOffers(){
            var offer_id =  $('#offerId').html();
            var sidebar = $('.lots-sidebar');
            if(sidebar.length > 0 && offer_id && offer_id.trim() !== ''){
                $.ajax({
                    url: '/manage/offers/side-menu-lots-count/'+offer_id,
                    data: {},
                    success: function(response) {
                        $('.auction-filter--added-count .count').html(response);
                        // updateTable(true);
                    }
                });
            }

        }


        /* offer end */





        $('body').on('click', function (e) {
            if ($(e.target).hasClass('add-to-order-action')) {
                e.preventDefault();

                var product_id = $(e.target).attr('product_id');
                var order_id =  $('#order-id').html();
                if(order_id.length < 1){
                    order_id = null;
                }

                var row = $(e.target).parents().eq(2);

                var price= row.find('.price-holder').val();
                if(price < 0.01){
                    row.find('.price-holder').addClass('error');
                }
                else{
                    $.ajax({
                        url: '/manage/order/toggle-product-to-order-ajax',
                        data: {
                            "product": product_id,
                            "order": order_id,
                            "price": price,
                            "add": true
                        },
                        success: function(response) {
                            row.find('.price-holder').removeClass('error');
                            var cloned_row = row.clone();
                            cloned_row.find(".add-to-order-action").addClass('remove-from-order-action').removeClass('add-to-order-action').html('REMOVE').attr('item', response);
                            cloned_row.appendTo("#package-table-body");
                            var amount = number_format(parseFloat(price), 2, ',', ',');
                            cloned_row.find('.price-holder').parent().html('€'+amount);
                            row.remove();
                            updateTable(true);
                        }
                    });
                }      
            }
        });

        $('body').on('click', function (e) {
            if ($(e.target).hasClass('add-service-to-order-action')) {
                e.preventDefault();

                var service_id = $(e.target).attr('service_id');
                var order_id =  $('#order-id').html();
                if(order_id.length < 1){
                    order_id = null;
                }
                var row = $(e.target).parents().eq(2);
                var price =  $(e.target).attr('price');
                
                $.ajax({
                    url: '/manage/order/toggle-service-to-order-ajax',
                    data: {
                        "service": service_id,
                        "order": order_id,
                        "price": price,
                        "add": true
                    },
                    success: function(response) {
                        var cloned_row = row.clone();
                        cloned_row.find(".add-to-order-action").addClass('remove-from-order-action').removeClass('add-to-order-action').html('REMOVE').attr('item', response);
                        cloned_row.appendTo("#package-table-body");
                        var amount = number_format(parseFloat(price), 2, ',', ',');
                        cloned_row.find('.price-holder').parent().html('€'+amount);
                        row.remove();
                        updateTable(true);
                    }
                });
                    
            }
        });

        $('body').on('click', function (e) {
            if ($(e.target).hasClass('remove-service-from-order-action')) {
                e.preventDefault();

                var service_id = $(e.target).attr('item');
                var order_id =  $('#order-id').html();
                if(order_id.length < 1){
                    order_id = null;
                }
                var row = $(e.target).parents().eq(2);
                //console.log(service_id);
                //console.log(order_id);
                $.ajax({
                    url: '/manage/order/toggle-service-to-order-ajax',
                    data: {
                        "service": service_id,
                        "order": order_id,
                        "price": 0,
                        "add": false
                    },
                    success: function(response) {
                        row.remove();
                        updateTable(true);
                    }
                });
                    
            }
        });

        $('body').on('click', function (e) {
            if ($(e.target).hasClass('remove-from-order-action')) {
                e.preventDefault();

                var product_id = $(e.target).attr('item');
                var order_id =  $('#order-id').html();
                if(order_id.length < 1){
                    order_id = null;
                }

                var row = $(e.target).parents().eq(2);

               
                $.ajax({
                    url: '/manage/order/toggle-product-to-order-ajax',
                    data: {
                        "product": product_id,
                        "order": order_id,
                        "price": 0,
                        "add": false
                    },
                    success: function(response) {
                        row.remove();
                        updateTable(true);
                    }
                });
                    
            }
        });

        function number_format(number, decimals, dec_point, thousands_sep) {
            number = number.toFixed(decimals);
    
            var nstr = number.toString();
            nstr += '';
            var x = nstr.split('.');
            var x1 = x[0];
            var x2 = x.length > 1 ? dec_point + x[1] : '';
            var rgx = /(\d+)(\d{3})/;
    
            while (rgx.test(x1))
                x1 = x1.replace(rgx, '$1' + thousands_sep + '$2');
    
            return x1 + x2;
        }

        $('body').on('click', function (e) {
            if ($(e.target).hasClass('remove-from-pack-action')) {
                e.preventDefault();

                var product_id = $(e.target).attr('product_id');
                var package_id =  $('#package-id').html();

                if(package_id.length < 1){
                    package_id = null;
                }

                var row = $(e.target).parents().eq(2);
                row.remove();
               

                $.ajax({
                    url: '/manage/package/toggle-product-to-package-ajax',
                    data: {
                        "product": product_id,
                        "package": package_id,
                        "add": false
                    },
                    success: function(response) {
                        
                        $('#package-id').html(response);
                        updateTable(true);
                    }
                });
            }
        });

        $(document).on('change paste keyup', '#pack-name-field', function () {
            var package_id =  $('#package-id').html();
            if(package_id.length < 1){
                package_id = null;
            }
            var title = $(this).val();
            if(title.length < 1){
                title = "Untitled"
            }

            $.ajax({
                url: '/manage/package/rename-package-ajax',
                data: {
                    "package": package_id,
                    "title": title
                },
                success: function(response) {
                    $('#package-id').html(response);
                }
            });

        });

        $(document).on('click', '.add-user-to-storage', function (e) {
            var user_id = $(this).attr('user_id');
            var storage_id = $('#storageid').html();
            // console.log(storage_id);
            
            $.ajax({
                type: 'GET',
                url: '/manage/storage/add-user-ajax',
                data: {
                    "user_id": user_id,
                    "storage_id": storage_id
                },
                success: function(response) {
                    updateTable(true);
                }
            });
        });

        $(document).on('click', '.remove-user-from-storage', function (e) {
            var user_id = $(this).attr('user_id');
            var storage_id = $('#storageid').html();
            
            $.ajax({
                type: 'GET',
                url: '/manage/storage/remove-user-ajax',
                data: {
                    "user_id": user_id,
                    "storage_id": storage_id
                },
                success: function(response) {
                    updateTable(true);
                }
            });
        });

        $(document).on('click', '.add-country-visibility', function (e) {
            var country_id = $(this).attr('country_id');
            
            $.ajax({
                type: 'GET',
                url: '/manage/global-settings/countries/add-visibility-ajax',
                data: {
                    "country_id": country_id,
                },
                success: function(response) {
                    updateTable(true);
                }
            });
        });

        $(document).on('click', '.remove-country-visibility', function (e) {
            var country_id = $(this).attr('country_id');
            
            $.ajax({
                type: 'GET',
                url: '/manage/global-settings/countries/remove-visibility-ajax',
                data: {
                    "country_id": country_id,
                },
                success: function(response) {
                    updateTable(true);
                }
            });
        });

        $(document).on('click', '.add-user-to-level', function (e) {
            var user_id = $(this).attr('user_id');
            var storage_id = $('#levelid').html();
            
            $.ajax({
                type: 'GET',
                url: '/manage/authorization-level/add-user-ajax',
                data: {
                    "user_id": user_id,
                    "level_id": storage_id
                },
                success: function(response) {
                    updateTable(true);
                }
            });
        });

        $(document).on('click', '.remove-user-from-level', function (e) {
            var user_id = $(this).attr('user_id');
            var storage_id = $('#levelid').html();
            
            $.ajax({
                type: 'GET',
                url: '/manage/authorization-level/remove-user-ajax',
                data: {
                    "user_id": user_id,
                    "level_id": storage_id
                },
                success: function(response) {
                    updateTable(true);
                }
            });
        });

        $(document).on('click', '.add-user-to-email', function (e) {
            var user_id = $(this).attr('user_id');
            var email_id = $('#emailid').html();
            
            $.ajax({
                type: 'GET',
                url: '/manage/custom-email-template/add-user-ajax',
                data: {
                    "user_id": user_id,
                    "email_id": email_id
                },
                success: function(response) {
                    updateTable(true);
                }
            });
        });

        $(document).on('click', '.remove-user-from-email', function (e) {
            var user_id = $(this).attr('user_id');
            var email_id = $('#emailid').html();
            
            $.ajax({
                type: 'GET',
                url: '/manage/custom-email-template/remove-user-ajax',
                data: {
                    "user_id": user_id,
                    "email_id": email_id
                },
                success: function(response) {
                    updateTable(true);
                }
            });
        });
    
        updateLotSideMenu();
        updateLotSideMenuCount();
        updateLotSideMenuOffers();
        updateLotSideMenuCountOffers();

        $('.reorder-table tbody').sortable({
            items: 'tr',
            cursor: 'pointer',
            handle: '.priority-icon',
            axis: 'y',
            start: function (e, ui) {
                // ui.item.addClass("selected");
            },
            stop: function (e, ui) {
                var field_id = ui.item.find('.priority-icon').attr('fieldid');
                var next_priority = ui.item.next().find('.priority-icon').attr('priority');
                var prev_priority = ui.item.prev().find('.priority-icon').attr('priority');
                
                $.ajax({
                    type: 'POST',
                    url: '/manage/user-data-field/priority-change-ajax',
                    data: {
                        'field_id' : field_id,
                        'next_priority' : next_priority,
                        'prev_priority' : prev_priority
                    },
                    success: function(response) {  
                
                        updateTable(true);
                        
                    }
                });
            }
        });

        $('.header-table tbody').sortable({
            items: 'tr',
            cursor: 'pointer',
            handle: '.priority-icon',
            axis: 'y',
            start: function (e, ui) {
                // ui.item.addClass("selected");
            },
            stop: function (e, ui) {
                var field_id = ui.item.find('.priority-icon').attr('fieldid');
                var next_priority = ui.item.next().find('.priority-icon').attr('priority');
                var prev_priority = ui.item.prev().find('.priority-icon').attr('priority');
                //console.log(field_id);
                //console.log(next_priority);
                //console.log(prev_priority);
                $.ajax({
                    type: 'POST',
                    url: '/manage/header/priority-change-ajax',
                    data: {
                        'field_id' : field_id,
                        'next_priority' : next_priority,
                        'prev_priority' : prev_priority
                    },
                    success: function(response) {  
                
                        updateTable(true);
                        
                    }
                });
            }
        });

        $('.footer-table tbody').sortable({
            items: 'tr',
            cursor: 'pointer',
            handle: '.priority-icon',
            axis: 'y',
            start: function (e, ui) {
                // ui.item.addClass("selected");
            },
            stop: function (e, ui) {
                var field_id = ui.item.find('.priority-icon').attr('fieldid');
                var next_priority = ui.item.next().find('.priority-icon').attr('priority');
                var prev_priority = ui.item.prev().find('.priority-icon').attr('priority');
                //console.log(field_id);
                //console.log(next_priority);
                //console.log(prev_priority);
                $.ajax({
                    type: 'POST',
                    url: '/manage/footer/priority-change-ajax',
                    data: {
                        'field_id' : field_id,
                        'next_priority' : next_priority,
                        'prev_priority' : prev_priority
                    },
                    success: function(response) {  
                
                        updateTable(true);
                        
                    }
                });
            }
        });

    },

    innerLotScripts() {
        function fetchCurrentBids(){
            $.ajax({
                url: window.location.href + '/bids',
                type: 'GET',
                success: function(response){
                    updateLotPrices(response);
                }
            })
        }

        function updateLotPrices(data){
            data.forEach(function(item){
                // 1. Update the lot's current bid
                $(`.current-amount-socketed[lot_id="${item.lot_id}"]`).html(item.amount);

                // 2. Update the bid count
                $(`.bid_count_${item.lot_id}`).html(item.bidsCount);

                // 3. Update the input value and quick bid buttons
                const input = $(`.bid-input-socketed[lot_id="${item.lot_id}"]`);
                const step = input.attr('step'); // Get increment step

                // input.val(parseInt(item.amount) + parseInt(step));

                // Quick bid buttons update
                $(`.quick-bid1[lot_id="${item.lot_id}"] .quick-value`).html(item.amount + parseInt(step));
                $(`.quick-bid2[lot_id="${item.lot_id}"] .quick-value`).html(item.amount + parseInt(step) * 2);
                $(`.quick-bid3[lot_id="${item.lot_id}"] .quick-value`).html(item.amount + parseInt(step) * 3);

                // 4. Update winning/losing visual state
                const currentUserId = $('#current_user_id').html();
                const productCard = $(`.product-card[lot_id="${item.lot_id}"]`);

                if (item.winning_user == currentUserId) {
                    productCard.addClass('winning').removeClass('losing');
                } else {
                    productCard.removeClass('winning').addClass('losing');
                }
            })
        }

        $(window).on('pageshow', function (event) {
            const refreshInterval = setInterval(fetchCurrentBids, 1000);

            $(window).on('beforeunload', function () {
                clearInterval(refreshInterval);
            })
        });
    },

    marketplaceScrips(){

        var selected_category_val = $('#category').val();
        $("*[categories]").each(function( index ) {
            var categories = $(this).attr('categories');
            if(categories.includes(selected_category_val) && selected_category_val != ''){
                $(this).show();
            }
            else{
                $(this).hide();
            }
        });
    
        $('#category').on('select2:select', function(){
            var selected_category_val = $(this).val();
            $("*[categories]").each(function( index ) {
                var categories = $(this).attr('categories');
                if(categories.includes(selected_category_val) && selected_category_val != ''){
                    $(this).show();
                }
                else{
                    $(this).hide();
                }
            });
        });

        //
        function fetchCurrentBids(){
            var currentPage = $('#current-page').val()-1;
            var searchedText = $('#table-search').val();
            var perPage = $('#per-page-selector').val();
            $.ajax({
                url: window.location.href + '/bids',
                data: {
                    "page": currentPage,
                    "per_page": perPage,
                    "filters" : gatherFilters(true),
                    "search" : searchedText,
                },
                type: 'GET',
                success: function(response){
                    updateLotPrices(response);
                }
            })
        }

        function updateLotPrices(data){
            data.forEach(function(item){
                // 1. Update the lot's current bid
                $(`.current-amount-socketed[lot_id="${item.lot_id}"]`).html(item.amount);

                // 2. Update the bid count
                $(`.bid_count_${item.lot_id}`).html(item.bidsCount);

                // 3. Update the input value and quick bid buttons
                const input = $(`.bid-input-socketed[lot_id="${item.lot_id}"]`);
                const step = input.attr('step'); // Get increment step

                // input.val(parseInt(item.amount) + parseInt(step));

                // Quick bid buttons update
                $(`.quick-bid1[lot_id="${item.lot_id}"] .quick-value`).html(item.amount + parseInt(step));
                $(`.quick-bid2[lot_id="${item.lot_id}"] .quick-value`).html(item.amount + parseInt(step) * 2);
                $(`.quick-bid3[lot_id="${item.lot_id}"] .quick-value`).html(item.amount + parseInt(step) * 3);

                // 4. Update winning/losing visual state
                const currentUserId = $('#current_user_id').html();
                const productCard = $(`.product-card[lot_id="${item.lot_id}"]`);

                if (item.winning_user == currentUserId) {
                    productCard.addClass('winning').removeClass('losing');
                } else {
                    productCard.removeClass('winning').addClass('losing');
                }
            })
        }

        $(window).on('pageshow', function (event) {
            if (event.persisted || performance.getEntriesByType("navigation")[0].type === 'back_forward') {
                $('.auction-lots--filter button[value='+sessionStorage.getItem('filter')+']').addClass( "active" );
                $('#total-pages-count').html(sessionStorage.getItem('total-pages'));
                $('#marketplace-to-refresh').html('');
                updateTable(false);

            } else {
                $('.auction-lots--filter button:first-child').addClass( "active" );
                sessionStorage.setItem('filter', $('.auction-lots--filter button:first-child').attr('value'));
                sessionStorage.setItem('total-pages',$('#total-pages-count').html());
            }

            const currentRoute = window.location.pathname;
            if (
                (currentRoute.startsWith("/marketplace") && currentRoute !== "/marketplace-buy-now") ||
                (currentRoute.startsWith("/my-favorites-1") && currentRoute !== "/my-favorites-buynow") ||
                /^\/auction\/\d+$/.test(currentRoute) // Matches `/auction/{id}` where `{id}` is a number
            ) {
                const refreshInterval = setInterval(fetchCurrentBids, 1000);

                $(window).on('beforeunload', function () {
                    clearInterval(refreshInterval);
                })
            }
        });

		$(document).on('click', '.next', function (e) {
            e.preventDefault();
            var currentPage = $('#current-page').val();

			if(parseInt($('#total-pages-count').html()) >= parseInt(currentPage)+1){
                $('#current-page').val(parseInt(currentPage)+1);
				updateTable(false);
			}
        });

		$(document).on('click', '.prev', function (e) {
            e.preventDefault();
            var currentPage = $('#current-page').val();
            
            if(currentPage > 1){
                $('#current-page').val(parseInt(currentPage)-1);
                updateTable(false);
            }
        });

        //on search field ENTER press
        $(document).on('keypress', '#table-search', function (e) {
            if(e.key == 'Enter') {
                var searchedText = this.value;
                updateTable(true);
            }
        });

        //on search field icon click
        $(document).on('click', '#table-search-submit', function (e) {
            updateTable(true);
        });

		$(document).on('keypress', '#current-page', function (e) {
            if(e.key == 'Enter') {
                updateTable(false);
            }
        });

        $(document).on('change', '#per-page-selector', function () {
            updateTable(true);
        });

        $(document).on('click', '.auction-lots--filter-item.bidding', function() {
            $('.auction-lots--filter-item.bidding').each(function(i, obj) {
                if($(this).hasClass('active')){
                    $(this).removeClass('active')
                }
            });
            $(this).addClass( "active" );
            updateTable(true);
        });

        $(document).on('click', '.auction-lots--filter-item.type', function() {
            $('.auction-lots--filter-item.type').each(function(i, obj) {
                if($(this).hasClass('active')){
                    $(this).removeClass('active')
                }
            });
            $(this).addClass( "active" );
            sessionStorage.setItem('filter', $(this).attr('value'));
            updateTable(true);
        });

        $(document).on('change', '#detailed-filters-box select', function () {
            var changedFieldId = $(this).attr('name');
            var selectedOptionId = $(this).val();
            var relatedFields = $( "select[related_id*='"+changedFieldId+"']" );

            relatedFields.each(function(i, obj) {
                $(this).val(null).trigger("change");
                $(this).find('option').each(function() {
                    if($(this).attr('related_option') !== selectedOptionId){
                        $(this).attr('disabled','disabled');
                    }
                    else{
                        $(this).removeAttr('disabled');
                    }
                });
                $(this).prop("disabled", false);
            });
        });

        $(document).on('click', '#detailed-filter-submit', function() {
            updateTableFilter(true);
        });

        $(document).on('click', '.clear-all-filters', function() {
            updateTable(true);
        });

        function gatherFilters($detailed){
            var filtersList = {};
            $('.auction-lots--filter-item').each(function(i, obj) {
                if($(this).hasClass('active')){
                    var type = $(this).attr('type');
                    var value = $(this).attr('value');

                    if(!filtersList[type]){
                        filtersList[type] = [];
                    }
                    filtersList[type].push(value);
              
                }
            });

            if($detailed){
                var detailedFilters = {}
                var category = $('#category-filter-box select').val();
                var margin = $('#margin-filter-box select').val();
                $('#detailed-filters-box select').each(function(i, obj) {
                    if($(this).attr('categories').includes(category)){
                        detailedFilters[$(this).attr('name')] = $(this).val();
                    }
                });
                $('#detailed-filters-box input').each(function(i, obj) {
                    if($(this).attr('categories').includes(category)){
                        detailedFilters[$(this).attr('name')] = $(this).val();
                    }
                });
                filtersList['category'] = category;
                filtersList['margin'] = margin;
                filtersList['detailed_filters_array'] = detailedFilters;
            }
            else{
                filtersList['category'] = null;
                filtersList['detailed_filters_array'] = [];
            }
            
            return filtersList;
        }

        function reInitSelects(){
            let select = $('select.select2');
            if (select.length > 0) {
                select.select2({
                    minimumResultsForSearch: 5,
                });
            }

            let multipleOptions = {
                placeholder: 'Select',
                closeOnSelect : false,
                allowClear: true,
                minimumResultsForSearch: 5
            };
    
            $('select.settings-multi').select2(multipleOptions);

            let selectAllSelect = $('.select-all');
            selectAllSelect.on('select2:select', function () {
                let thisSelect = $(this);
                if (thisSelect.val().includes('Select all')) {
                    thisSelect.select2('destroy').find('option').prop('selected', 'selected').end().select2(multipleOptions);
                }
            });
    
            selectAllSelect.on('select2:unselect', function (e) {
                if (e.params.data.text === 'Select all') {
                    $(this).val(null).trigger('change');
                }
            });

            var selected_category_val = $('#category').val();
            $("*[categories]").each(function( index ) {
                var categories = $(this).attr('categories');
                if(categories.includes(selected_category_val) && selected_category_val != ''){
                    $(this).show();
                }
                else{
                    $(this).hide();
                }
            });
        }

		function updateTable(reset = false){
            if(reset == true){
                var currentPage = 0;
                $('#current-page').val(1)
            }
            else
                var currentPage = $('#current-page').val()-1;

            var searchedText = $('#table-search').val();
            var perPage = $('#per-page-selector').val();
            let loader = $('.loader-holder');
            loader.show();
            $.ajax({
                url: window.location.href,
                data: {
                    "page": currentPage,
                    "per_page": perPage,
                    "filters" : gatherFilters(true),
                    "search" : searchedText,
                },
                success: function(response) {
                    loader.fadeOut(300);
                    $('#marketplace-to-refresh').html(response['rows']);
                    $('#total-pages-count').html(response['pages']);
                    sessionStorage.setItem('total-pages',response['pages']);
                    $( ".time-countDown" ).each(function( index ) {
                        let date =  $(this).attr("data-countDown");
                        $(this).countdown(date, function(event) {
                            $(this).html(event.strftime('%-Dd. %Hh %-Mmin'));
                        });
                    });

                    $('.make-user-bid').on('click', function (e) {
                        let input = $(this).parent().find('.user-bid-input');
                        let auction = input.attr('data-auction');
                        let lot = input.attr('data-lot');
                        let bid = parseInt(input.val());

                        if(bid>0 && auction>0 && lot>0 && input[0].checkValidity() == true) {
                            e.preventDefault();
                            $('.bid-approve-popup').fadeIn().removeClass('d-none');

                            $('.pop-up-close').click(function() {
                                $('.bid-approve-popup').fadeOut();
                                $('.pop-up-close').off('click');
                                $('.close-pop').off('click');
                            });

                            $('.close-pop').click(function() {
                                $('.bid-approve-popup').fadeOut();
                                $('.pop-up-close').off('click');
                                $('.close-pop').off('click');
                                loader.show();
                                $.ajax({
                                    type: 'POST',
                                    url: '/make-bid/' + auction + '/' + lot,
                                    data: {
                                        'bid': bid
                                    },
                                    success: function (response) {
                                        if(response["error"]==0){
                                            //conn.send('{"amount" : '+response["amount"]+', "lot_id": '+response["lot_id"]+', "winning_user": '+response["winning_user"]+', "bidsCount": '+response["bidsCount"]+'}');
                                        } else{
                                            alert(response["error_txt"]);
                                        }
                                        loader.fadeOut(300);
                                    }
                                });
                            });
                        }
                    });

                    $('.product-card--favorite').on('click',function(){
                        const $this = $(this);
                        const productId = $this.data('id');

                        $.ajax({
                            url: `/favorite/${productId}`,
                            method: 'POST',
                            data: {
                            },
                            success: function (isFavorite) {
                                if (isFavorite) {
                                    $this.addClass('active');
                                } else {
                                    $this.removeClass('active');
                                }
                            },
                            error: function (xhr) {
                            }
                        });
                    })
                    // // $('#detailed-filters-box').html(response['detailedFiltersHtml']);

                    reInitSelects();
                }
            });
        }

        function updateTableFilter(reset = false){
            if(reset){
                var currentPage = 0;
                $('#current-page').val(1)
            }
            else{
                var currentPage = $('#current-page').val();
                
            }
            var searchedText = $('#table-search').val();
            var perPage = $('#per-page-selector').val();
            let loader = $('.loader-holder');
            loader.show();
            $.ajax({
                url: window.location.href,
                data: {
                    "page": currentPage,
                    "per_page": perPage,
                    "filters" : gatherFilters(true),
                    "search" : searchedText,
                },
                success: function(response) {
                    loader.fadeOut(300);
                    $('#marketplace-to-refresh').html(response['rows']);
                    $('#total-pages-count').html(response['pages']);
                    sessionStorage.setItem('total-pages',response['pages']);
                    $( ".time-countDown" ).each(function( index ) {
                        let date =  $(this).attr("data-countDown");
                        $(this).countdown(date, function(event) {
                            $(this).html(event.strftime('%-Dd. %Hh %-Mmin'));
                        });
                    });

                    $('.make-user-bid').on('click', function (e) {
                        let input = $(this).parent().find('.user-bid-input');
                        let auction = input.attr('data-auction');
                        let lot = input.attr('data-lot');
                        let bid = parseInt(input.val());

                        if(bid>0 && auction>0 && lot>0 && input[0].checkValidity() == true) {
                            e.preventDefault();
                            $('.bid-approve-popup').fadeIn().removeClass('d-none');

                            $('.pop-up-close').click(function() {
                                $('.bid-approve-popup').fadeOut();
                                $('.pop-up-close').off('click');
                                $('.close-pop').off('click');
                            });

                            $('.close-pop').click(function() {
                                $('.bid-approve-popup').fadeOut();
                                $('.pop-up-close').off('click');
                                $('.close-pop').off('click');
                                loader.show();
                                $.ajax({
                                    type: 'POST',
                                    url: '/make-bid/' + auction + '/' + lot,
                                    data: {
                                        'bid': bid
                                    },
                                    success: function (response) {
                                        if(response["error"]==0){
                                            //conn.send('{"amount" : '+response["amount"]+', "lot_id": '+response["lot_id"]+', "winning_user": '+response["winning_user"]+', "bidsCount": '+response["bidsCount"]+'}');
                                        } else{
                                            alert(response["error_txt"]);
                                        }
                                        loader.fadeOut(300);
                                    }
                                });
                            });
                        }
                    });

                    $('.product-card--favorite').on('click',function(){
                        const $this = $(this);
                        const productId = $this.data('id');

                        $.ajax({
                            url: `/favorite/${productId}`,
                            method: 'POST',
                            data: {
                            },
                            success: function (isFavorite) {
                                if (isFavorite) {
                                    $this.addClass('active');
                                } else {
                                    $this.removeClass('active');
                                }
                            },
                            error: function (xhr) {
                            }
                        });
                    })
                }
            });
        }
    },

    builderScrips(){

        //ON PER PAGE CHANGE
       /* $(document).on('change paste keyup', 'input', function () {
            var page_id = $('#page-id').html();
            var fd = new FormData();
            if(this.type == 'file'){
                var file = $('input[name="'+this.name+'"]')[0].files[0];
                fd.append(this.name, file);
            }
            if(this.type == 'checkbox'){
                fd.append(this.name, $(this).is(":checked"));
            }
            else{
                if(this.name == 'page_slug'){
             
                    $('#preview-slug').attr('href', '/'+this.value);
                }
                fd.append(this.name, this.value);
            }

            $.ajax({
                type: 'POST',
                url: '/manage/page/save-parameter/'+page_id,
                processData: false, // important
                contentType: false, // important            
                data: fd,
                success: function(response) {
                  
                }
            });
        });*/

        // SAVE
        var form = document.querySelector('form');
        form.onsubmit = function() {

            $(".text-editor").each(function() {
                var text = $(this).summernote('code');

                if(text.length > 0){
                    var name = $(this).attr('name');
                    $('<input>', {
                        type: 'hidden',
                        name: name,
                        value: JSON.stringify(text)
                    }).appendTo('form');
                }
            });


            return true;
        };

        /* $('.text-editor .ql-editor').on('DOMSubtreeModified', function(){
            var page_id = $('#page-id').html();
            var text = $(this).html();
            var fd = new FormData();
            fd.append($(this).parent().attr('name'), text);
        
            $.ajax({
                type: 'POST',
                url: '/manage/page/save-parameter/'+page_id,
                processData: false, // important
                contentType: false, // important            
                data: fd,
                success: function(response) {
                 
                }
            });
        }); */



        $(document).on('click', '.save-and-preview', function() {

            $('#page-builder').attr('target' ,'_blank');
            $('#preview-status').val(1);
            $('#page-builder').submit();
        });

        $(document).on('click', '.save', function() {

            $('#page-builder').attr('target' ,'');
            $('#preview-status').val(0);
            $('#page-builder').submit();
        });



        $(document).on('click', '.element-reorder-up, .element-reorder-down', function() {
            var $el, $row;
            $el = $(this);
            $row = $el.parents('.page-layout');
            var layoutId = $row.attr('layoutid');
            // move row up or down one row
            if ( $el.hasClass('element-reorder-up') && $row.not(':first-child') ) {
                $row.prev().before($row);
                /*$.ajax({
                    type: 'POST',
                    url: '/manage/page/priority-decrease/'+layoutId,   
                    data: {},
                    success: function(response) {
                       
                    }
                });*/
            } 
            else if ( $el.hasClass('element-reorder-down') &&  $row.not(':last-child') ) {
                $row.next().after($row);
                /*$.ajax({
                    type: 'POST',
                    url: '/manage/page/priority-increase/'+layoutId,   
                    data: {},
                    success: function(response) {
                       
                    }
                });*/
            }
        });

        $(document).on('click', '.add-page-layout-slide', function() {
            var page = $(this).attr('page');
            var template = $(this).attr('template');
            $.ajax({
                type: 'POST',
                url: '/manage/page/add-layout-ajax/'+page+'/'+template,
                data: {},
                success: function(response) {
                    var element = response;
                    $('#layout-forms').append(element);

                        $('.text-editor').summernote({
                            tableClassName: function()
                            {
                                $(this).addClass('table table-bordered').attr('cellpadding', 12)
                                .attr('cellspacing', 0)
                                .attr('border', 1)
                                .css('borderCollapse', 'collapse');
                        
                                $(this).find('td')
                                .css('borderColor', '#ccc')
                                .css('padding', '15px');
                            }
                        });
                }
            });
        });

        $(document).on('click', '.page-layout-delete', function() {
            var layout = $(this).attr('layout');
            $(this).parent().parent().remove();
            /*$.ajax({
                type: 'POST',
                url: '/manage/page/remove-layout-ajax/'+layout,
                data: {},
                success: function(response) {
                    $('#layout-forms').append(response);
                }
            });*/
        });
        
    },

    editCategoryScrips(){

        
        // $(document).on('change', '#category_generatedTitleFields', function() {
        //     var category_id = $('#category-id').html();
        //     // console.log($(this).val());
        //     $.ajax({
        //         type: 'POST',
        //         url: '/manage/products/categories/rearange/'+category_id,
        //         data: {
        //             'list' : $(this).val(),
        //         },
        //         success: function(response) {
        //             //$('#layout-forms').append(response);
                    
        //             console.log(response);
        //         }
        //     });
            
        // });



        // $('#category-sorter .ui-sortable').on('DOMSubtreeModified', function(){
        //     var category_id = $('#category-id').html();
        //     var all = $("#category-sorter .ui-sortable .select2-selection__choice__display").map(function() {
        //         return this.innerHTML;
        //     }).get();

        //     console.log(all);
        //     // console.log($('.ui-sortable .select2-selection__choice__display').html());
        //     $.ajax({
        //         type: 'POST',
        //         url: '/manage/products/categories/rearange/'+category_id,
        //         data: {
        //             'list' : all,
        //         },
        //         success: function(response) {
        //             //$('#layout-forms').append(response);
                    
        //             console.log(response);
        //         }
        //     });
        // });

        $(document).on('click', '.toggle-field-in-category', function() {
            var add_action = $(this).attr('add_action');
            var field_id = $(this).attr('fieldid');
            var field_required = $(this).attr('fieldrequired');
            var title = $(this).attr('title');
            var category_id = $('#category-id').html();

            if(add_action == 'true'){
                $(this).replaceWith( '<a add_action=false title="'+title+'" fieldId="'+field_id+'" fieldRequired="'+field_required+'" class="dark-button min-vw-auto toggle-field-in-category">Remove</a>');
                if(field_required == 'true'){
                    $('#category_generatedTitleFields').append($('<option>', {
                        value: field_id,
                        text: title
                    }));
                }
                $('#category_uniqueField').append($('<option>', {
                    value: field_id,
                    text: title
                }));
            }
            else{
                $(this).replaceWith('<a add_action=true title="'+title+'" fieldId="'+field_id+'" fieldRequired="'+field_required+'" class="grey-button min-vw-auto toggle-field-in-category">ADD</a>');
                $("#category_generatedTitleFields").find('[value="'+field_id+'"]').remove();
                $("#category_uniqueField").find('[value="'+field_id+'"]').remove();
            }

            $.ajax({
                type: 'POST',
                url: '/manage/products/categories/toggle-field-for-category/'+category_id,
                data: {
                    'add_action' : add_action,
                    'field_id' : field_id,
                },
                success: function(response) {
                    //$('#layout-forms').append(response);
                    
                  
                }
            });
        });
    },

    categoryFieldScripts(){


        
        if($('#category_field_type').val() == 'select'){
            $('.make-options-tab').show();
            $('.visible-checkbox').show();
        }
        else if($('#category_field_type').val() == 'long_text'){
            $('.make-options-tab').hide();
            $('.visible-checkbox').hide();
        }
        else{
            $('.make-options-tab').hide();
            $('.visible-checkbox').show();
        }

        $(document).on('change', '#category_field_type', function() {
            if($('#category_field_type').val() == 'select'){
                $('.make-options-tab').show();
                $('.visible-checkbox').show();
            }
            else if($('#category_field_type').val() == 'long_text'){
                $('.make-options-tab').hide();
                $('.visible-checkbox').hide();
            }
            else{
                $('.make-options-tab').hide();
                $('.visible-checkbox').show();
            }
        });


        $(document).on('click', '#create-option-btn', function() {
            var title = $('#create_option_title').val();
            $('#create_option_title').removeClass('error')


            var value = $('#create_option_title').val().replace(/\s+/g, '_').toLowerCase();
            // $('#create_option_value').removeClass('error')

            var related = $('#create_option_related').val();
            //console.log(related);

            var category_field_id = $('#category-field-id').html();
            
            if(title.length < 1){
                $('#create_option_title').addClass('error')
            }
            if(value.length < 1){
                $('#create_option_value').addClass('error')
            }

            if(title.length >= 1 && value.length >= 1 && category_field_id.length >= 1){
                $.ajax({
                    type: 'GET',
                    url: '/manage/products/categories-fields/add-option-ajax',
                    data: {
                        'category_field_id' : category_field_id,
                        'title' : title,
                        'value' : value,
                        'related' : related,
                    },
                    success: function(response) {
                       
                        $('#create_option_title').val('');
                        $('#create_option_value').val('');
                        $('#create_option_related').val('');
                        refreshTable();
                    }
                });
            } 
        });

        $(document).on('click', '.next', function() {
            var pages_count = $('#pages-count').html();
            var current_page = $('#current-page').val();
            if( (parseInt(current_page)+1) <= pages_count){
                $('#current-page').val(parseInt(current_page)+1)
                refreshTable();
            }
        });

        $(document).on('click', '.prev', function() {
            var current_page = $('#current-page').val();
            if(current_page > 1){
                $('#current-page').val(parseInt(current_page)-1);
                refreshTable();
            }
        });

        $(document).on('keyup', '.edit-option-title, .edit-option-value', function() {
            $(this).parent().parent().parent().find( ".edit-option-btn" ).show();
            $(this).parent().parent().parent().find( ".delete-option-btn" ).hide();
            // console.log($(this).attr('name'));
        });
        $(document).on('change', '.edit-option-relation', function() {
            $(this).parent().parent().parent().find( ".edit-option-btn" ).show();
            $(this).parent().parent().parent().find( ".delete-option-btn" ).hide();
            // console.log($(this).attr('name'));
        });

        $(document).on('click', '.edit-option-btn', function() {

            var option_id = $(this).attr('optionid');
            var title = $(this).parent().parent().find( ".edit-option-title" ).val();
            // var value = $(this).parent().parent().find( ".edit-option-value" ).val();
            var value = title.replace(/\s+/g, '_').toLowerCase();
            var relation = $(this).parent().parent().find( ".edit-option-relation" ).val();
            $.ajax({
                type: 'GET',
                url: '/manage/products/categories-fields/edit-option-ajax',
                data: {
                    'option_id' : option_id,
                    'title' : title,
                    'value' : value,
                    'related' : relation,
                },
                success: function(response) {
                   
                }
            });

            $(this).parent().find( ".edit-option-btn" ).hide();
            $(this).parent().find( ".delete-option-btn" ).show();
        });

        $(document).on('click', '.delete-option-btn', function() {

            var option_id = $(this).attr('optionid');  
     
            $.ajax({
                type: 'GET',
                url: '/manage/products/categories-fields/delete-option-ajax',
                data: {
                    'option_id' : option_id,
                },
                success: function(response) {
                    
                    $(this).parent().parent().remove();
                    refreshTable();

                }
            });

        });

        

        function reInitSelects(){
            let select = $('select.select2');
            if (select.length > 0) {
                select.select2({
                    minimumResultsForSearch: 5
                });
            }

            let multipleOptions = {
                placeholder: 'Select',
                closeOnSelect : false,
                allowClear: true,
                minimumResultsForSearch: 5
            };
    
            $('select.settings-multi').select2(multipleOptions);

            let selectAllSelect = $('.select-all');
            selectAllSelect.on('select2:select', function () {
                let thisSelect = $(this);
                if (thisSelect.val().includes('Select all')) {
                    thisSelect.select2('destroy').find('option').prop('selected', 'selected').end().select2(multipleOptions);
                }
            });
    
            selectAllSelect.on('select2:unselect', function (e) {
                if (e.params.data.text === 'Select all') {
                    $(this).val(null).trigger('change');
                }
            });
        }

        function refreshTable(){
            var current_page = $('#current-page').val();
            var category_field_id = $('#category-field-id').html();

            $.ajax({
                type: 'GET',
                url: '/manage/products/categories-fields/get-options-ajax',
                data: {
                    'category_field_id' : category_field_id,
                    'page' : current_page
                },
                success: function(response) {  
            
                    $('#table-to-update').html(response);
                    reInitSelects();
                }
            });
        }


    },

    userFieldScripts(){
        
    },

    productScripts(){
        $('.remove-photo').on('click', function(){
            $(this).parent().remove();
        });
    
        $('#submit-btn').on('click', function(e){
            if($('form')[0].checkValidity()){
                e.preventDefault();
                var required_fields = document.querySelectorAll('#fields_block :required');
                if(required_fields.length > 0){
                    required_fields.forEach(function(el) {
                        $.ajax({
                            type: "POST",
                            url: "/manage/products/info/check-uniq",
                            data: {
                                field_id: el.name,
                                value: el.value,
                                product_id: $('#product-id').html(),
                                category_id: $('#product_category').val(),
                            },
                            dataType: "json",
                            success: function(response) {
                                if(response){
                                    $('#product_title').prop('disabled', false);
                                    $('#product_title').prop('readonly', true);
                                    $('form').submit();
                                    // if($('#product-id').html() != ""){
                                    //     $.ajax({
                                    //         type: "POST",
                                    //         url: "/manage/products/info/check-status",
                                    //         data: {
                                    //             product_id: $('#product-id').html(),
                                    //         },
                                    //         dataType: "json",
                                    //         success: function(response) {
                                    //             if(response){
                                    //                 alert('Product is already in auction!');
                                    //             }
                                    //             else{
                                    //                 $('#product_title').prop('disabled', false);
                                    //                 $('#product_title').prop('readonly', true);
                                    //                 $('form').submit();
                                    //             }
                                    //         }
                                    //     });
                                    // } else {
                                    //     $('#product_title').prop('disabled', false);
                                    //     $('#product_title').prop('readonly', true);
                                    //     $('form').submit();
                                    // }
                                }
                                else{
                                    el.setCustomValidity("Please enter a unique value");
                                    el.reportValidity();
                                    el.addEventListener('input', function(){
                                        el.setCustomValidity("");
                                    });
                                }
                            }
                        });
                    });
                }
                else{
                    $('#product_title').prop('disabled', false);
                    $('#product_title').prop('readonly', true);
                    $('form').submit();
                }
            }
        });
    
        var product_title_field = $('#product_title');
        var selected_category_option = $('#product_category option:selected');
        var selected_category_val = $('#product_category').val();
        // console.log(selected_category_option);
        // console.log(selected_category_val);
        // console.log($('#product_category').find(':selected'));
        // console.log($('#product_category').select2('val'));
        $("*[categories]").each(function( index ) {
            var categories = $(this).attr('categories');
            var categories_unique = $(this).attr('categories_unique');
            if(categories.includes(selected_category_val) && selected_category_val != ''){
    
                $(this).show();
                if($(this).hasClass('required') && categories_unique.includes(selected_category_val)){
                    $(this).prop('required',true);
                    var label_for = $(this).attr('name');
                    $("label[for='"+label_for+"'] span").show();
                } else {
                    if($(this).hasClass('required')){
                        $(this).prop('required',false);
                        var label_for = $(this).attr('name');
                        $("label[for='"+label_for+"'] span").hide();
                    }
                }
    
            }
            else{
                $(this).hide();
                if($(this).hasClass('required')){
                    $(this).prop('required',false);
                    var label_for = $(this).attr('name');
                    $("label[for='"+label_for+"'] span").hide();
                }
            }
        });
        //console.log($('#product_category option:selected').attr('useGeneratedTitle'));
        if(selected_category_val != '' && selected_category_option.attr('useGeneratedTitle') == 'false'){
            product_title_field.prop('required', true);
            product_title_field.prop('disabled', false);
        } else {
            product_title_field.prop('required', false);
            product_title_field.prop('disabled', true);
        }
    
        $('#product_category').on('select2:select', function(){
            var selected_category_val = $(this).val();
            var selected_category_option = $('#product_category option:selected');
            $("*[categories]").each(function( index ) {
                var categories = $(this).attr('categories');
                var categories_unique = $(this).attr('categories_unique');
                if(categories.includes(selected_category_val) && selected_category_val != ''){
                    $(this).show();
                    if($(this).hasClass('required') && categories_unique.includes(selected_category_val)){
                        $(this).prop('required',true);
                        var label_for = $(this).attr('name');
                        $("label[for='"+label_for+"'] span").show();
                    } else {
                        if($(this).hasClass('required')){
                            $(this).prop('required',false);
                            var label_for = $(this).attr('name');
                            $("label[for='"+label_for+"'] span").hide();
                        }
                    }
                }
                else{
                    $(this).hide();
                    if($(this).hasClass('required')){
                        $(this).prop('required',false);
                        var label_for = $(this).attr('name');
                        $("label[for='"+label_for+"'] span").hide();
                    }
                }
            });
            if(selected_category_val != '' && selected_category_option.attr('useGeneratedTitle') == 'false'){
                product_title_field.prop('required', true);
                product_title_field.prop('disabled', false);
            } else {
                product_title_field.prop('required', false);
                product_title_field.prop('disabled', true);
            }
        });

        const option = [];
    
        $('#fields_block select').each(function(){
            
            var changed_field_id = $(this).attr('name');
            var selected_option = $(this).val();
    
            var related_input = $("#fields_block").find("[related_field='" + changed_field_id + "']");
    
            if(!option[changed_field_id])
                option[changed_field_id] = related_input.html();
            else
                related_input.html( option[changed_field_id] );

            if(related_input.length > 0){
                var all_options = related_input.find("option");
                all_options.each(function( index ) {
                    if($(this).attr('related_option') !== selected_option){
                        $(this).remove(); // hide/show dont work ir some browsers..
                    } else $(this).show();
                });
            }
        });
        
        $('#fields_block select').on('select2:select', function(){
            
            var changed_field_id = $(this).attr('name');
            var selected_option = $(this).val();
    
            var related_input = $("#fields_block").find("[related_field='" + changed_field_id + "']");
    
            if(!option[changed_field_id])
                option[changed_field_id] = related_input.html();
            else
                related_input.html( option[changed_field_id] );
    
            if(related_input.length > 0){
                related_input.val('null');
                var all_options = related_input.find("option");
                all_options.each(function( index ) {
                    if($(this).attr('related_option') !== selected_option){
                        $(this).remove(); // hide/show dont work ir some browsers..
                    } else $(this).show();
                });
            }
        });
    },

    userRoleScripts(){

        var form = document.querySelector('form');
        form.onsubmit = function() {
            let count = 1;
            $(".text-editor").each(function() {

                var text = $(this).summernote('code');
                text = text.replace('<p><br></p>','');
                if(text.length > 0){
                    var name = $(this).attr('name').concat(count);

                    $('<input>', {
                        type: 'hidden',
                        name: name,
                        value: JSON.stringify(text)
                    }).appendTo('form');

                    count = count + 1;
                }
            });


            return true;
        };

        $('.sortable-list').sortable({
            items: '.add-row-wrap:not(.new-row)',
            cursor: 'pointer',
            axis: 'y',
            handle: '.priority-icon',
        });

        // add-row-wrap
        $('body').on('click', function (e) {
            if ($(e.target).hasClass('add-row') && $(e.target).hasClass('new')) {
                let parent = $(e.target).closest('.add-row-wrap');
                parent.find('.input-wrap').removeClass('error');
                let validation = true;

                if (validation ==  true) {
                    parent.find('.input-wrap').removeClass('error');
                    let clonedRow = parent.clone();
                    clonedRow.insertBefore(parent).attr('id', 'new' + getRandomInt(9, 9999));
                    parent.parent().find('.add-row-wrap').eq(1).removeClass('new-row').find('.add-row.new').hide();
                    parent.parent().find('.add-row-wrap.new-row .text-editor-wrap')[0].innerHTML = '<div name="text" class="text-editor"></div>';
                    $('.add-row-wrap.new-row .text-editor').summernote({
                        tableClassName: function()
                        {
                            $(this).addClass('table table-bordered').attr('cellpadding', 12)
                            .attr('cellspacing', 0)
                            .attr('border', 1)
                            .css('borderCollapse', 'collapse');
                    
                            $(this).find('td')
                            .css('borderColor', '#ccc')
                            .css('padding', '15px');
                        }
                    });
                    parent.parent().find('.add-row-wrap').eq(1).find('.add-row.delete').addClass('show');

                    $('.sortable-list').sortable({
                        items: '.add-row-wrap:not(.new-row)',
                        cursor: 'pointer',
                        axis: 'y',
                        handle: '.priority-icon',
                    });
                }
            }
        });

        $('body').on('click', function (e) {
            if ($(e.target).hasClass('add-row') && $(e.target).hasClass('delete')) {
                $(e.target).parent().parent().remove();
            }
        });
        
        function getRandomInt(min, max) {
            min = Math.ceil(min);
            max = Math.floor(max);
            return Math.floor(Math.random() * (max - min) + min);
        }
    },

    restrictionNoticeScripts(){
        // $('#submit-btn').on('click', function(e){
        //     e.preventDefault();
        //     var text = $(".text-editor").summernote('code');
        //     console.log(text.length);
        //     var name = $('.text-editor').attr('name');
        //     console.log(name);
        //     $('<input>', {
        //         type: 'hidden',
        //         name: name,
        //         value: JSON.stringify(text)
        //     }).appendTo('form');
        //     console.log(document.querySelector('form'));
        // });
        var form = document.querySelector('form');
        form.onsubmit = function() {
            $(".text-editor").each(function() {
                var text = $(this).summernote('code');

                if(text.length > 0){
                    var name = $(this).attr('name');
                    $('<input>', {
                        type: 'hidden',
                        name: name,
                        value: JSON.stringify(text)
                    }).appendTo('form');
                }
            });


            return true;
        };
    },

    globalSettingsScripts(){
        if($('#global_settings_authenticatedMarketplace').is(':checked')){
            $('#global_settings_verifiedMarketplace').parent().parent().show();
        } else {
            $('#global_settings_verifiedMarketplace').parent().parent().hide();
        }

        $('#global_settings_authenticatedMarketplace').on('change', function() { 
            if (this.checked) {
                $('#global_settings_verifiedMarketplace').parent().parent().show();
            } else {
                $('#global_settings_verifiedMarketplace').parent().parent().hide();
            }
        });
    },

    emailTemplateScripts(){
        var form = document.querySelector('form');
        form.onsubmit = function() {
            document.getElementById('email_template_body').value = $(".text-editor").summernote('code');
        };
    },

    customEmailTemplateScripts(){
        var form = document.querySelector('form');
        form.onsubmit = function() {
            document.getElementById('custom_email_template_body').value = $(".text-editor").summernote('code');
        };
    },

    deeealerDataMappingFieldOptionsScripts(){
        $(".primary-table--body--item").each(function () {
            const row = $(this);
            const deeealerOption = row.find("td:first").text().trim()
                .replace(/[\s-]+/g, '_').toLowerCase(); // Get {{option.deeealerOption}}
            const select = row.find("select.form-input"); // Get the related <select>

            if (select.val() === "") { // If <select> is not selected
                select.find("option").each(function () {
                    const option = $(this);
                    const optionText = option.text().trim()
                        .replace(/[\s-]+/g, '_').toLowerCase();
                    if (optionText === deeealerOption) { // Match text with {{option.deeealerOption}}
                        option.prop("selected", true); // Auto-select
                        if (select.next(".form-text").length === 0) {
                            // Add the div to indicate auto-selection
                            select.after('<div class="form-text">Automatically selected</div>');
                        }
                        return false; // Exit the loop
                    }
                });
            }
        });
    },

    offerScripts(){
        const priceTypeSelector = $('.price-type-selector');
        const totalPriceInput = $('[name="offer[totalPrice]"]');
        const offerId = $('input[name="offer[id]"]').val() || 0;

        function updateTotalPrice(){
            const priceTypeId = priceTypeSelector.val();

            if (!priceTypeId) {
                totalPriceInput.val('');
                return;
            }

            $.ajax({
                url: '/manage/offers/recalculate-total-price',
                method: 'POST',
                dataType: 'json',
                data: {
                    priceTypeId: priceTypeId,
                    offerId: offerId,
                },
                success: function (response) {
                    if (response.totalPrice !== undefined) {
                        totalPriceInput.val(parseFloat(response.totalPrice).toFixed(2));
                    } else if (response.error) {
                        alert('Error: ' + response.error);
                    }
                },
                error: function (xhr, status, error) {
                    console.error('Failed to update total price:', error);
                },
            });
        }

        if(offerId !== 0){
            updateTotalPrice();
            priceTypeSelector.on('change', updateTotalPrice);
        }
    },
}